export const name = 'LocalStorageService';

import { useMainStore } from '@/stores/main'

export function isWorking()
{
  if (typeof(Storage) !== "undefined") {
    return true;
  } else {
    console.error("No localStorage support on this browser!");
    return false;
  }
}

export function get(key)
{
  if (!isWorking()){
    return;
  }
  return JSON.parse(localStorage.getItem(key));
}

export function set(key, value)
{
  if (!isWorking()){
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
}

export function loadState()
{
  const store = useMainStore()
  let state = get('state');
  if (!state){
    return;
  }
  for (var key in state){
    store[key] = {...state[key]}
  }
}

export function saveState()
{
  const toSave = [
    'auth',
    'settings'
  ]
  const store = useMainStore()
  let newState = {};
  for (let i in toSave){
    let key = toSave[i]
    newState[key] = {...store[key]}
  }
  set('state', newState);
}
